<div class="cube-game" [class.is-immersive]="isFullscreen" *ngIf="round">

  <!-- Prompt -->
  <div class="prompt-bar">
    <span class="prompt-icon" aria-hidden="true">🐠</span>
    <span class="prompt-text">{{ currLang === 'ar'
      ? 'كم وحدة مكعبة تملأ الحوض؟ اضبط المقياس واسكب!'
      : 'How many cubic units fill the tank? Set the gauge & pour!' }}</span>
  </div>

  <!-- Whose turn -->
  <div class="turn-chip" *ngIf="student">
    <app-student-avatar [student]="student" [size]="46" [active]="true"></app-student-avatar>
    <div class="turn-text">
      <span class="turn-name">{{ studentName }}</span>
      <span class="turn-label">{{ currLang === 'ar' ? 'دورك!' : "it's your turn" }}</span>
    </div>
  </div>

  <!-- Round progress -->
  <div class="round-dots">
    <span class="dot" *ngFor="let d of roundDots; let i = index"
          [class.done]="solvedFlags[i]" [class.current]="i === currentRound"></span>
  </div>

  <!-- Interactive stage -->
  <div class="stage-wrap">
    <app-cube-fill-stage
      [round]="round"
      [roundKey]="currentRound"
      [interactive]="!resolving"
      [currLang]="currLang"
      (solved)="onSolved()"
      (missed)="onMissed()">
    </app-cube-fill-stage>
  </div>

  <!-- Controls -->
  <div class="controls">
    <button class="ctrl-btn nudge-btn" [disabled]="resolving" (click)="stage?.nudge(-1)" aria-label="less">−</button>
    <button class="ctrl-btn pour-btn" [disabled]="resolving || !stage?.canPour" (click)="onPour()">
      {{ currLang === 'ar' ? 'اسكب!' : 'POUR' }}
      <span aria-hidden="true">🫗</span>
    </button>
    <button class="ctrl-btn nudge-btn" [disabled]="resolving" (click)="stage?.nudge(1)" aria-label="more">+</button>
    <button class="ctrl-btn skip-btn" [disabled]="resolving" (click)="skip()">
      {{ currLang === 'ar' ? 'تخطّي' : 'Skip' }}
    </button>
  </div>

  <!-- Success -->
  <div class="success-overlay" *ngIf="showSuccess">
    <div class="success-card">
      <span class="success-icon" aria-hidden="true">🐠</span>
      <span class="success-eq">{{ round.l }} × {{ round.w }} × {{ round.h }} = {{ round.volume }}</span>
      <span class="success-xp" *ngIf="lastXp > 0">+{{ lastXp }} XP</span>
    </div>
  </div>

  <app-fullscreen-toggle [isFullscreen]="isFullscreen" [currLang]="currLang" (toggle)="toggleFullscreen()"></app-fullscreen-toggle>
</div>
